import React from 'react';
import styled from 'styled-components/macro';
import { uiColors } from '../../common/styles';
import AddToCartButtonBase from '../common/AddToCartButtonBase';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
`;

const ButtonSubText = styled.p`
    font-size: 12px;
    text-align: center;
    margin: 0px 6px;
    color: ${uiColors.SECONDARY_TEXT}
`

const AddToCartButton = ({ className, subText }) => {
    return (
        <Wrapper>
            <AddToCartButtonBase className={`${className} action-button uppercase`} />
            <ButtonSubText>{subText}</ButtonSubText>
        </Wrapper>

    );
};

export default AddToCartButton;
